// covered-by: frontends/carrie/src/ask-v2/home/__tests__/useAskV2MentionTasks.test.ts
import { useMemo } from "react";

import {
  type AskV2MentionTask,
  mentionTasksFromNotifications,
} from "./mentionTasks";

import { ASK_PUNTT_UNREAD_LIST_POLL_MS } from "../../utils/queries/askPuntt";
import { useCurrentUserProfile } from "../../utils/queries/userProfile";

export type AskV2MentionTasksState = {
  tasks: AskV2MentionTask[];
  pending: boolean;
};

/**
 * Unread @mention tasks for the home page, read off the profile's stored
 * notifications. Polls at the sidebar's unread cadence so a mention posted
 * while the reader sits on the home lands within one poll.
 */
export function useAskV2MentionTasks(): AskV2MentionTasksState {
  const profile = useCurrentUserProfile({
    refetchInterval: ASK_PUNTT_UNREAD_LIST_POLL_MS,
  });
  const notifications = profile.data?.notifications;
  const tasks = useMemo(
    () => mentionTasksFromNotifications(notifications),
    [notifications],
  );
  return { tasks, pending: profile.isPending };
}
